import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["StartIcon", "EndIcon", "children", "disabled", "fullwidth", "twStyle", "indicator", "loading", "onClick", "testId", "size", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { forwardRef, useMemo } from 'react';
import { Spinner } from '../spinner';
import Title from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ButtonV2 = /*#__PURE__*/forwardRef(function (props, ref) {
  var StartIcon = props.StartIcon,
      EndIcon = props.EndIcon,
      children = props.children,
      disabled = props.disabled,
      fullwidth = props.fullwidth,
      twStyle = props.twStyle,
      indicator = props.indicator,
      loading = props.loading,
      _onClick = props.onClick,
      testId = props.testId,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'primary' : _props$variant,
      restProps = _objectWithoutProperties(props, _excluded);

  var iconSizeClasses = '!h-5 !w-5';
  var iconColorClasses = useMemo(function () {
    return iconColors[variant];
  }, [variant]);
  var iconClasses = useMemo(function () {
    return "".concat(iconSizeClasses, " ").concat(disabled ? 'text-neutral-100' : iconColorClasses);
  }, [disabled, iconColorClasses]);
  var isTextOnlyButtonLoading = useMemo(function () {
    return !StartIcon && !EndIcon && loading;
  }, [EndIcon, StartIcon, loading]);
  var startIconEl = useMemo(function () {
    return StartIcon && loading ? /*#__PURE__*/_jsx(StyledSpinner, {
      className: iconSizeClasses,
      color: buttonToSpinnerVariantMap[variant],
      size: size
    }) : StartIcon ? /*#__PURE__*/_jsx(StartIcon, {
      className: iconClasses
    }) : null;
  }, [StartIcon, iconClasses, loading, size, variant]);
  var endIconEl = useMemo(function () {
    return EndIcon && loading ? /*#__PURE__*/_jsx(StyledSpinner, {
      className: iconSizeClasses,
      color: buttonToSpinnerVariantMap[variant],
      size: size
    }) : EndIcon ? /*#__PURE__*/_jsx(EndIcon, {
      className: iconClasses
    }) : null;
  }, [EndIcon, iconClasses, loading, size, variant]);
  return /*#__PURE__*/_jsxs(StyledButton, _objectSpread(_objectSpread({
    ref: ref,
    size: size,
    variant: variant,
    onClick: function onClick(e) {
      // e.preventDefault();
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(e);
    },
    disabled: disabled,
    fullwidth: fullwidth,
    "data-cy": testId,
    twStyle: twStyle
  }, restProps), {}, {
    children: [startIconEl, /*#__PURE__*/_jsx(ContentWrapper, {
      isTextOnlyButtonLoading: isTextOnlyButtonLoading,
      children: children
    }), endIconEl, isTextOnlyButtonLoading && /*#__PURE__*/_jsx(LoadingOverlay, {
      children: /*#__PURE__*/_jsx(StyledSpinner, {
        size: size,
        className: iconSizeClasses,
        color: buttonToSpinnerVariantMap[variant]
      })
    }), /*#__PURE__*/_jsx(StyledOverlay, {
      disabled: disabled,
      variant: variant
    }), !!indicator && /*#__PURE__*/_jsx(StyledNotificationIndicator, {
      children: typeof indicator === 'number' && /*#__PURE__*/_jsx(Title, {
        textColor: "neutral-10",
        fontWeight: "semibold",
        twStyle: {
          "fontSize": "0.875rem !important",
          "lineHeight": "1.25rem !important"
        },
        children: indicator
      })
    })]
  }));
});
ButtonV2.displayName = 'ButtonV2';
export default ButtonV2;
var iconColors = {
  primary: 'text-purple-700',
  'secondary-neutral': 'text-neutral-700',
  'secondary-success': 'text-green-700',
  'secondary-warning': 'text-orange-700',
  'secondary-danger': 'text-red-700',
  'secondary-restworld': 'text-purple-700',
  'secondary-reversed': 'text-neutral-10',
  tertiary: 'text-neutral-700',
  'tertiary-reversed': 'text-neutral-10'
};
var buttonToSpinnerVariantMap = {
  primary: 'restworld',
  'secondary-neutral': 'neutral',
  'secondary-success': 'success',
  'secondary-warning': 'warning',
  'secondary-danger': 'error',
  'secondary-restworld': 'restworld',
  'secondary-reversed': 'reversed',
  tertiary: 'neutral',
  'tertiary-reversed': 'reversed'
};
var variantToOverlayBgMap = {
  primary: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(28 28 51 / var(--tw-bg-opacity))"
  },
  'secondary-neutral': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 26 / var(--tw-bg-opacity))"
  },
  'secondary-success': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 84 45 / var(--tw-bg-opacity))"
  },
  'secondary-warning': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(158 84 0 / var(--tw-bg-opacity))"
  },
  'secondary-danger': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(145 0 24 / var(--tw-bg-opacity))"
  },
  'secondary-restworld': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(102 51 187 / var(--tw-bg-opacity))"
  },
  'secondary-reversed': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 250 250 / var(--tw-bg-opacity))"
  },
  tertiary: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(28 28 51 / var(--tw-bg-opacity))"
  },
  'tertiary-reversed': {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }
};
var ButtonVariantStyles = {
  primary: {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(221 238 52 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  },
  'secondary-neutral': {
    "backgroundColor": "rgb(0 0 26 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))"
  },
  'secondary-restworld': {
    "backgroundColor": "rgb(102 51 187 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(72 36 133 / var(--tw-text-opacity))"
  },
  'secondary-success': {
    "backgroundColor": "rgb(0 84 45 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(0 84 45 / var(--tw-text-opacity))"
  },
  'secondary-warning': {
    "backgroundColor": "rgb(158 84 0 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(158 84 0 / var(--tw-text-opacity))"
  },
  'secondary-danger': {
    "backgroundColor": "rgb(145 0 24 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(145 0 24 / var(--tw-text-opacity))"
  },
  'secondary-reversed': {
    "backgroundColor": "rgb(250 250 250 / 0.1)",
    "--tw-text-opacity": "1",
    "color": "rgb(250 250 250 / var(--tw-text-opacity))"
  },
  tertiary: {
    "backgroundColor": "transparent",
    "--tw-text-opacity": "1",
    "color": "rgb(28 28 51 / var(--tw-text-opacity))",
    "--tw-shadow": "inset 0 0 0 1px #858591",
    "--tw-shadow-colored": "inset 0 0 0 1px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  },
  'tertiary-reversed': {
    "backgroundColor": "transparent",
    "--tw-text-opacity": "1",
    "color": "rgb(250 250 250 / var(--tw-text-opacity))",
    "--tw-shadow": "inset 0 0 0 1px #858591",
    "--tw-shadow-colored": "inset 0 0 0 1px var(--tw-shadow-color)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
  }
};

var StyledButton = /*#__PURE__*/_styled.button.withConfig({
  displayName: "button-v2__StyledButton",
  componentId: "sc-1vdbkua-0"
})(["", " ", " ", " ", " ", " ", ""], {
  "position": "relative",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "0.5rem",
  "borderRadius": "0.5rem",
  "paddingTop": "0.5rem !important",
  "paddingBottom": "0.5rem !important",
  "fontWeight": "600",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms",
  ":focus-visible": {
    "outlineWidth": "4px",
    "outlineColor": "#e88a99"
  },
  ":disabled": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(222 222 225 / var(--tw-bg-opacity))"
  }
}, function (_ref) {
  var size = _ref.size;
  return size === 'sm' ? {
    "height": "2rem !important",
    "paddingLeft": "0.75rem !important",
    "paddingRight": "0.75rem !important",
    "fontSize": "0.875rem !important",
    "lineHeight": "1.25rem !important"
  } : {
    "height": "3rem !important",
    "paddingLeft": "1rem !important",
    "paddingRight": "1rem !important",
    "fontSize": "1rem !important",
    "lineHeight": "1.5rem !important"
  };
}, function (_ref2) {
  var variant = _ref2.variant;
  return [ButtonVariantStyles[variant], {
    ":disabled": {
      "cursor": "not-allowed",
      "--tw-text-opacity": "1",
      "color": "rgb(102 102 118 / var(--tw-text-opacity))"
    }
  }];
}, function (_ref3) {
  var fullwidth = _ref3.fullwidth;
  return fullwidth ? {
    "width": "100%"
  } : {};
}, function (_ref4) {
  var disabled = _ref4.disabled,
      loading = _ref4.loading;
  return disabled || loading ? {
    "pointerEvents": "none",
    "cursor": "not-allowed"
  } : {
    "pointerEvents": "auto",
    "cursor": "pointer"
  };
}, function (_ref5) {
  var twStyle = _ref5.twStyle;
  return twStyle || {};
});

var StyledOverlay = /*#__PURE__*/_styled.span.withConfig({
  displayName: "button-v2__StyledOverlay",
  componentId: "sc-1vdbkua-1"
})(["", " ", " ", ""], {
  "position": "absolute",
  "top": "0px",
  "left": "0px",
  "right": "0px",
  "bottom": "0px",
  "borderRadius": "0.5rem",
  "opacity": "0",
  "transitionProperty": "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "200ms",
  ":hover": {
    "opacity": "0.15"
  },
  ":active": {
    "opacity": "0.2"
  }
}, function (_ref6) {
  var variant = _ref6.variant;
  return variantToOverlayBgMap[variant];
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled ? {
    ":hover": {
      "opacity": "0"
    },
    ":active": {
      "opacity": "0"
    }
  } : {};
});

var StyledNotificationIndicator = /*#__PURE__*/_styled.span.withConfig({
  displayName: "button-v2__StyledNotificationIndicator",
  componentId: "sc-1vdbkua-2"
})(["", ""], {
  "position": "absolute",
  "top": "-0.5rem",
  "right": "-0.5rem",
  "display": "grid",
  "height": "1.5rem",
  "width": "1.5rem",
  "placeItems": "center",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(204 0 34 / var(--tw-bg-opacity))"
});

var LoadingOverlay = /*#__PURE__*/_styled.span.withConfig({
  displayName: "button-v2__LoadingOverlay",
  componentId: "sc-1vdbkua-3"
})(["", ""], {
  "position": "absolute",
  "top": "0px",
  "left": "0px",
  "right": "0px",
  "bottom": "0px",
  "display": "grid",
  "placeItems": "center",
  "backgroundColor": "transparent"
});

var ContentWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "button-v2__ContentWrapper",
  componentId: "sc-1vdbkua-4"
})(["", ""], function (_ref8) {
  var isTextOnlyButtonLoading = _ref8.isTextOnlyButtonLoading;
  return isTextOnlyButtonLoading ? {
    "opacity": "0"
  } : {};
});

var StyledSpinner = /*#__PURE__*/_styled(Spinner).withConfig({
  displayName: "button-v2__StyledSpinner",
  componentId: "sc-1vdbkua-5"
})(["", ""], function (_ref9) {
  var size = _ref9.size;
  return size === 'md' ? {
    "position": "relative",
    "top": "-1.5px"
  } : {
    "position": "relative",
    "top": "-0.5px"
  };
});